<div class="grid grid-cols-12 gap-8">
    @if (isTomoDashboard) {
        <div class="col-span-12 xl:col-span-6">
            <app-tomo-orders-today [orders]="tomo.orders" [loading]="tomoLoading" />
        </div>
        <div class="col-span-12 xl:col-span-6">
            <app-tomo-branches-today [branches]="tomo.branches" />
        </div>
    } @else {
        <app-statswidget class="contents" />
        <div class="col-span-12 xl:col-span-6">
            <app-tableloans />
            <!-- <app-best-selling-widget /> -->
        </div>
        <div class="col-span-12 xl:col-span-6">
            <app-graphloans />
            <!-- <app-notifications-widget /> -->
        </div>
    }
</div>
